import React from "react";

const Events = () => {
  return (
    <div className="container mx-auto py-8">
      <h1>Events</h1>
    </div>
  );
};

export default Events;
